import { ItemView, util } from '@glu/core';

import template from './manageColumnsMenu.hbs';

export default ItemView.extend({
  template,

  className: 'grid-manage-columns-layout',

  ui: {
    $allColumns: '.grid-show-all-columns',
    $checkboxes: '.grid-show-column',
    $backdrop: '.grid-manage-columns-backdrop',
    $updateColumnsBtn: '.js-update-columns'
  },

  events: {
    'change @ui.$allColumns': 'handleShowAll',
    'click .js-update-columns': 'handleSave',
    'click .js-cancel': 'close',
    'change @ui.$checkboxes': 'handleCheckboxChange'
  },

  handleCheckboxChange(e) {
    const $target = this.$(e.target);
    const $checked = this.ui.$checkboxes.filter(':checked');

    this.setAllColumnsSelected();

    // do not allow the user to hide the last visible column
    if ($checked.length === 0) {
      $target.prop('checked', true);
    }
  },

  // Handle the selection of the 'show all' checkbox.
  handleShowAll(e) {
    const $target = this.$(e.target);
    const checked = $target.prop('checked');
    const { $checkboxes } = this.ui;

    // will always keep selected first checkbox if we are uncheck all columns
    for (let i = $checkboxes.length; i--; i === 0) {
      const $el = this.$($checkboxes[i]);

      if ($el.prop('checked') !== checked) {
        $el.trigger('click');
      }
    }
  },

  initialize() {
    this.grid = this.options.grid;
  },

  onRender() {
    this.setBackdropHeight();
    this.setAllColumnsSelected();
  },

  setFocusToFirstElement() {
    this.ui.$allColumns.focus();
  },

  onDomRefresh() {
    this.setFocusToFirstElement();
  },

  setAllColumnsSelected() {
    const $checked = this.ui.$checkboxes.filter(':checked');
    const iaAllChecked = $checked.length === this.ui.$checkboxes.length;

    this.ui.$allColumns.prop('checked', iaAllChecked);
  },

  setBackdropHeight() {
    this.ui.$backdrop.css('height', this.grid.$('section.content').outerHeight());
  },

  findModelByCid(cid) {
    return this.collection.find((model) => cid === model.cid);
  },

  serializeData() {
    return {
      // add checked and cid data to json
      rows: this.collection.chain().map((model) => {
        const checked = util.isFunction(model.get('condition')) ? model.get('condition')(model.get('field'), model) : (model.get('condition') !== false);
        return util.extend(model.toJSON(), {
          cid: model.cid,
          isChecked: checked
        });
        // remove columns that we can't edit
      }).reject((model) => model.disableRemove)
        // sort alphabetically
        .sortBy((model) => model.label || model.title)
        // group data into sets of 5 so we can wrap it in .row markup
        .groupBy((model, i) => Math.floor(i / 5))
        .values()
        .value()
    };
  },

  handleSave() {
    const columnsLastItemIndex = this.ui.$checkboxes.length - 1;

    util.each(this.ui.$checkboxes, (el, index) => {
      const $el = this.$(el);
      const model = this.findModelByCid($el.val());
      const showColumn = $el.prop('checked');

      if (model) {
        model.set('condition', showColumn, {
          // to prevent multiple grid re-rendering
          silent: true
        });

        if (index !== columnsLastItemIndex) {
          return;
        }

        // need to trigger change condition only after last element.
        this.collection.trigger('change:condition');
      }
    });

    this.close();
  }
});
